module.exports = "/_next/static/images/EngageCustomers-2cbefc77b83e408c12aac36db0ab8cc9.webp";